
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/pokemon-trainer",
      function () {
        return require("private-next-pages/landing/pokemon-trainer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/pokemon-trainer"])
      });
    }
  